var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAscendMulticolorBackgroundSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 240,
    viewBox: "0 0 343 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13742_235231)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 240,
    rx: 4,
    fill: "#994878",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.8748 57.1891C72.9118 59.4942 67.5589 63.1401 63.2304 67.8448C58.9018 72.5495 55.7136 78.1869 53.9123 84.321C52.1109 90.455 51.7448 96.9211 52.8423 103.219C53.9398 109.517 56.4713 115.479 60.2412 120.642L70.3396 113.269C67.7007 109.654 65.9286 105.482 65.1604 101.073C64.3921 96.6641 64.6484 92.1378 65.9093 87.844C67.1702 83.5502 69.402 79.604 72.432 76.3107C75.462 73.0174 79.209 70.4653 83.3831 68.8517L78.8748 57.1891Z",
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.495 176.188L19.6459 138.865L51.3931 158.524L18.495 176.188Z",
    fill: "#994878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M256.219 153.075L182.691 227.737C182.691 227.737 182.358 227.906 182.191 227.737L156.24 201.386C156.24 201.386 155.907 201.217 155.741 201.386L78.9684 279.342C76.889 281.453 78.3862 285 81.2974 285H378.74C381.651 285 383.065 281.453 381.068 279.342L256.718 153.075C256.718 153.075 256.386 152.907 256.219 153.075Z",
    fill: "#994878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13742_235231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 240,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendMulticolorBackgroundSmall);
export default __webpack_public_path__ + "static/media/AscendMulticolorBackgroundSmall.2257d317018c4f373d8bedb8d0026b42.svg";
export { ForwardRef as ReactComponent };